import {
  REPORT_INFO,
  REPORT_INFO_SUCCESS,
  REPORT_INFO_FAILURE,
} from "../actionTypes";

export const reportInfo = (payload) => ({
  type: REPORT_INFO,
  payload,
});

export const reportInfoSuccess = (payload) => ({
  type: REPORT_INFO_SUCCESS,
  payload,
});

export const reportInfoFailure = () => ({
  type: REPORT_INFO_FAILURE,
});
